import React from 'react';

import UsersTable from './components/UsersTable';

export function UsersPage() {
    return <UsersTable />;
}
